import StepEntityBase from "./step_entity_base.js";
/**
 * Implements the external mapping functionality.
 */
export default class StepExternalMapping extends StepEntityBase {
    /**
     * Get the type of this entity (0 is always external mapping)
     *
     * @return {number} The type code of this.
     */
    get type() {
        return 0;
    }
    /**
     * Construct this external mapping.
     *
     * @param localID The local ID for this.
     * @param internalReference_ The internal reference matching this.
     * @param model The model matching this.
     */
    constructor(localID, internalReference_, model) {
        super(localID, internalReference_, model);
    }
    /**
     * Get the externally mapped elements in this.
     *
     * @return {StepEntityBase} The inline elements of this.
     */
    get items() {
        if (this.items_ === void 0) {
            this.items_ = [];
            const inlineEntities = this.internalReference_.inlineEntities;
            if (inlineEntities !== void 0) {
                for (const inlineItem of inlineEntities) {
                    const inlineElement = this.model.getInlineElementByAddress(inlineItem.address);
                    if (inlineElement === void 0) {
                        continue;
                    }
                    this.items_.push(inlineElement);
                }
            }
        }
        return this.items_;
    }
}
StepExternalMapping.query = [0];
StepExternalMapping.expectedType = 0;
